/*
 * Shop Samples section
 *
 * Adds a sample to the cart without leaving the page, so a buyer can collect
 * several swatches in one pass. Uses the theme's own cart helpers
 * (Shopify.theme.cart / Shopify.theme.ajaxCart) so the cart count and drawer
 * contents stay in sync, but deliberately does not open the drawer on each add.
 *
 * The submit buttons use `js-samples-submit` rather than the theme's
 * `js-ajax-submit` so the global add-to-cart handler does not also fire and
 * double add the item.
 */
(function () {
  'use strict';

  var SELECTORS = {
    section: '[data-section-type="shop-samples"]',
    form: 'form',
    submit: '.js-samples-submit',
    swatch: '[data-ss-swatch]',
    image: '[data-ss-image]',
    nameTarget: '[data-ss-name-target]',
    priceTarget: '[data-ss-price-target]',
    addedMsg: '.js-added-msg',
    errorMsg: '.js-error-msg',
    errorMsgContent: '.js-error-msg-content'
  };

  var RESET_DELAY = 2500;

  function getCartConfig() {
    var el = document.getElementById('cart-config');
    if (!el) return null;

    try {
      return JSON.parse(el.innerHTML || '{}');
    } catch (e) {
      return null;
    }
  }

  function hasThemeCart() {
    return !!(
      window.Shopify &&
      Shopify.theme &&
      Shopify.theme.cart &&
      typeof Shopify.theme.cart.addItemFromForm === 'function'
    );
  }

  function show(element) {
    if (element) element.style.display = 'block';
  }

  function hide(element) {
    if (element) element.style.display = 'none';
  }

  function setButtonState(button, state) {
    var labels = {
      idle: button.getAttribute('data-add-label'),
      adding: button.getAttribute('data-adding-label'),
      added: button.getAttribute('data-added-label')
    };

    button.value = labels[state] || labels.idle || button.value;
    button.classList.toggle('is-adding', state === 'adding');
    button.classList.toggle('is-added', state === 'added');
    button.disabled = state === 'adding';
  }

  /* ---------- colorway selection ---------- */

  function onSwatchChange(event) {
    var input = event.target;
    if (!input.matches(SELECTORS.swatch)) return;

    var card = input.closest('.ss-card');
    if (!card) return;

    card.querySelectorAll('.ss-swatch').forEach(function (label) {
      label.classList.toggle('is-active', label.contains(input));
    });

    var name = input.getAttribute('data-ss-name');
    var nameTarget = card.querySelector(SELECTORS.nameTarget);
    if (nameTarget && name) nameTarget.textContent = name;

    var price = input.getAttribute('data-ss-price');
    var priceTarget = card.querySelector(SELECTORS.priceTarget);
    if (priceTarget && price) priceTarget.innerHTML = price;

    var src = input.getAttribute('data-ss-src');
    var image = card.querySelector(SELECTORS.image);
    if (image && src) {
      image.src = src;
      var srcset = input.getAttribute('data-ss-srcset');
      if (srcset) image.srcset = srcset;
    }

    // A fresh colorway is a fresh add, so clear any previous confirmation.
    var button = card.querySelector(SELECTORS.submit);
    if (button && button.classList.contains('is-added')) {
      setButtonState(button, 'idle');
    }
    hide(card.querySelector(SELECTORS.addedMsg));
    hide(card.querySelector(SELECTORS.errorMsg));
  }

  /* ---------- add to cart ---------- */

  function refreshCart(config) {
    if (!config || !Shopify.theme.ajaxCart || !Shopify.theme.cart.getCart) return;

    Shopify.theme.cart.getCart().then(function (cart) {
      Shopify.theme.ajaxCart.updateView(config, cart);
    });
  }

  function showError(form, error) {
    var errorMsg = form.querySelector(SELECTORS.errorMsg);
    var errorContent = form.querySelector(SELECTORS.errorMsgContent);

    if (error && typeof error.json === 'function') {
      error
        .json()
        .then(function (body) {
          if (errorContent && body && body.description) {
            errorContent.textContent = body.description;
          }
        })
        .catch(function () {})
        .then(function () {
          show(errorMsg);
        });
    } else {
      show(errorMsg);
    }
  }

  function onSubmit(event) {
    var button = event.currentTarget;
    var form = button.closest('form');
    if (!form) return;

    // No theme cart available, let the browser post the form as normal.
    if (!hasThemeCart()) return;

    event.preventDefault();

    if (button.disabled) return;

    var config = getCartConfig();
    var addedMsg = form.querySelector(SELECTORS.addedMsg);
    var errorMsg = form.querySelector(SELECTORS.errorMsg);

    hide(addedMsg);
    hide(errorMsg);
    setButtonState(button, 'adding');

    Shopify.theme.cart
      .addItemFromForm(form)
      .then(function () {
        setButtonState(button, 'added');
        show(addedMsg);
        refreshCart(config);

        window.setTimeout(function () {
          setButtonState(button, 'idle');
          hide(addedMsg);
        }, RESET_DELAY);
      })
      .catch(function (error) {
        setButtonState(button, 'idle');
        showError(form, error);

        window.setTimeout(function () {
          hide(form.querySelector(SELECTORS.errorMsg));
        }, RESET_DELAY);
      });
  }

  /* ---------- init ---------- */

  function initSection(section) {
    if (!section || section.dataset.ssBound === 'true') return;
    section.dataset.ssBound = 'true';

    section.querySelectorAll(SELECTORS.submit).forEach(function (button) {
      button.addEventListener('click', onSubmit);
    });

    section.addEventListener('change', onSwatchChange);
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTORS.section).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.matches && event.target.matches(SELECTORS.section)) {
      initSection(event.target);
    } else {
      init(event.target);
    }
  });
})();
